import $ from 'jquery';
import defaults from 'lodash/defaults';

export default function horizontalScrollMenu(targetElement, options) {

  options = options || {}
  defaults(options, {
    //selectedClassName: 'selected'
    fixed: true,
    scrollMenu: '.js-scroll-menu',
    scrollItem: '.scroll-menu__item',
    scrollItemActive: 'scroll-menu__item--active',
    scrollMenuFixed: 'scroll-menu--fixed',
    speed: 200,
  })

  //Apply active class for styling (mobile)
  $(options.scrollItem).on("click", function(){
    var thisItem = $(this);
    thisItem.siblings().removeClass(options.scrollItemActive).end().addClass(options.scrollItemActive);
  });

  //Fix Designer Menu header on scroll
  var fixedMenu = function(){
    if(options.fixed){
      var element = $(options.scrollMenu);
      var elementHeight = $(element).outerHeight(true);
      var scrollPosY = $(window).scrollTop();
      var elementOffset = ($(element).offset().top + elementHeight);
      var distance = (elementOffset - scrollPosY);

      if (scrollPosY > distance) {
        element.addClass(options.scrollMenuFixed);
      } else {
        element.removeClass(options.scrollMenuFixed);
      }
    }
  }

  //Adjust anchor scroll based on fixed header
  var adjustAnchor = function() {
    var $anchor = $(':target');
    var element = $(options.scrollMenu);
    var elementHeight = $(element).outerHeight(true);

    if ($anchor.length > 0) {
      $('html, body')
        .stop()
        .animate({
            scrollTop: $anchor.offset().top - elementHeight
        }, options.speed);
        console.log('hit');
    }
  };

  $(window).on('scroll resize', fixedMenu);
  $(window).on('hashchange load', adjustAnchor);

} //End horizontalScrollMenu



// WEBPACK FOOTER //
// ./src/scripts/entry-points/designers/horizontal-scroll-menu.js